import { StyledModalActions, StyledModalContent, StyledModalHeader } from "./Printer/StyledModal";
import styled, { Button, StyledModal } from "grabcad-ui-elements";
import { Role, useCompanyAsAdminQuery } from "../graphql";
import { useContext } from "react";
import { ApplicationContext } from "../components/ApplicationProvider";
import { useAcceptTOS } from "../graphql/Mutations/Companies";
import { UserContext } from "../components/User/UserProvider";
import { isEmbeddedInGrabCADPrint } from "../utils/isGrabCADPrint";

const StyledTOSModal = styled(StyledModal)`
    background: #0000 !important;

    & > .actions {
        border-bottom-left-radius: 10px !important;
        border-bottom-right-radius: 10px !important;
    }
`;

function broadcastCancelToGrabCADPrint() {
    window.grabcadPrintContextBridge?.termsOfServiceDeclined();
}

interface ITermsOfServiceModalProps {
    logout: () => void;
}

export function TermsOfServiceModal({ logout }: ITermsOfServiceModalProps): React.ReactElement {
    const { t } = useContext(ApplicationContext);
    const [acceptTOS] = useAcceptTOS();
    const { role } = useContext(UserContext);
    const { company } = useCompanyAsAdminQuery();

    const showModal = role === Role.CompanyAdmin && company && company.tosState !== "ACCEPTED";

    const declineAction = isEmbeddedInGrabCADPrint ? broadcastCancelToGrabCADPrint : logout;

    const declineActionText = isEmbeddedInGrabCADPrint ? t("tos.cancel") : t("tos.logout");

    return (
        <StyledTOSModal centered size="mini" open={showModal}>
            <StyledModalHeader content={t("tos.header")} />
            <StyledModalContent>
                <p>
                    {`${t("tos.by_clicking_on")} "${t("tos.accept")}", ${t(
                        "tos.you_confirm_that"
                    )} `}
                    <a href="https://grabcad.com/terms" target="_blank" rel="noreferrer noopener">
                        {t("tos.terms_of_service")}
                    </a>
                    {", "}
                    <a
                        href="https://grabcad.com/software_terms"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        {t("tos.software_terms")}
                    </a>
                    {` ${t("tos.and")} `}
                    <a
                        href="https://grabcad.com/privacy_policy"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        {t("tos.privacy_policy")}
                    </a>
                    {` ${t("tos.and_that_you")}`}
                </p>
            </StyledModalContent>
            <StyledModalActions>
                <Button secondary onClick={declineAction}>
                    {declineActionText}
                </Button>
                <Button
                    id="qa-accept-tos"
                    primary
                    onClick={() => {
                        void acceptTOS();
                    }}
                >
                    {t("tos.accept")}
                </Button>
            </StyledModalActions>
        </StyledTOSModal>
    );
}
